<template>
  <div class="container-entities">
    <p>
      Crea bases con fecha de caducidad. Son ideales para campañas que tienen límite de tiempo.
      <a href="http://securitec.pe" target="_blank" rel="noopener noreferrer">Click aquí</a> para
      conocer más.
    </p>
    <a-row class="controls" type="flex" justify="space-between">
      <a-col>
        <a-form layout="inline" @submit.prevent="handleFetchBases">
          <a-form-item>
            <a-input v-model:value="search" placeholder="Buscar..." class="form__input">
              <template #prefix>
                <SearchOutlined />
              </template>
            </a-input>
          </a-form-item>
          <a-form-item v-if="user?.customer.type_business == 1">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="selectedEntity"
              placeholder="Seleccione empresa"
              class="form__select"
              @change="handleEntityChange"
            >
              <a-select-option :key="0"> Todas las empresas </a-select-option>
              <a-select-option v-for="entity in entities" :key="entity.id">
                {{ entity.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="selectedPortfolio"
              placeholder="Seleccione campaña"
              class="form__select"
              @change="handlePortfolioChange"
            >
              <a-select-option :key="0"> Todos las campañas </a-select-option>
              <a-select-option v-for="portfolio in portfolios" :key="portfolio.id">
                {{ portfolio.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col>
        <ModalAddBase :type-business="user?.customer ? user?.customer.type_business : 1" />
      </a-col>
    </a-row>
    <TableBases />
  </div>
</template>

<script>
import ModalAddBase from "@/app/entities/components/modals/bases/modalBases/ModalAddBase.vue";
import TableBases from "@/app/entities/components/tables/TableBases.vue";
import { defineComponent } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    ModalAddBase,
    TableBases,
    SearchOutlined,
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    user() {
      return this.$store.getters["getDataUser"];
    },
    selectedEntity: {
      get() {
        return this.$store.getters["getSelectedEntity"];
      },
      set(entityId) {
        this.$store.dispatch("setSelectedEntity", entityId);
      },
    },
    selectedPortfolio: {
      get() {
        return this.$store.getters["getSelectedPortfolio"];
      },
      set(portfolioId) {
        this.$store.dispatch("setSelectedPortfolio", portfolioId);
      },
    },
    entities() {
      return this.$store.getters["getEntityList"];
    },
    portfolios() {
      return this.$store.getters["getFilteredPortfolios"];
    },
  },
  created() {
    this.$store.dispatch("fetchAllEntities");
    this.handleFetchBases();
  },
  methods: {
    handleFetchBases() {
      this.$store.dispatch("fetchAllBases", {
        filters: {
          search: this.search,
          entity: this.selectedEntity,
          portfolio: this.selectedPortfolio,
        },
      });
      this.$store.dispatch("fetchAllPortfoliosByEntity", {
        filters: {
          entity: this.selectedEntity,
        },
      });
    },
    handleEntityChange() {
      this.selectedPortfolio = 0;
      this.handleFetchBases();
    },
    handlePortfolioChange(value) {
      const portfolio = this.portfolios.find((item) => value == item.id);
      const entityId = portfolio?.entity?.id;
      if (entityId) this.$store.dispatch("setSelectedEntity", entityId);
      this.handleFetchBases();
    },
  },
});
</script>

<style lang="sass" scoped>
.ant-form-item
  margin-bottom: 20px

.container-entities
  padding: 8px 20px

.controls
  margin-bottom: 8px

.entradaBoton
  display: flex
  justify-content: space-between
  margin-top: 20px
  margin-bottom: 24px
  widows: 100%

.form__input
  width: 380px

.form__select
  width: 180px !important
</style>
